<div class="wrapper">
    <app-admin-panel-sidebar-menu></app-admin-panel-sidebar-menu>
    <main class="main">
        <app-admin-panel-header></app-admin-panel-header>
        <div class="overlay" (click)="removeOverlay()"></div>
        <div class="overlay-filter" (click)="removeFilterbar()"></div>
        <div class="main-content">
            <div class="content-title d-flex align-items-center d-md-none mb-3">
                <app-breadcrumb></app-breadcrumb>
            </div>
            <router-outlet></router-outlet>
        </div>
    </main>
</div>